const WA_GENERAL = 'https://wa.me/526675680042?text=Hola%2C%20quiero%20contratar%20mi%20membresia%20Coverly';
const CALL_ADVISOR = 'tel:526675680042';

export default function PricingFinalCTA() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Three%20generation%20Mexican%20family%20light%20skin%20grandparents%20seated%20parents%20and%20grandchildren%20gathered%20around%20them%20warm%20golden%20afternoon%20sunlight%20living%20room%20interior%20genuine%20smiles%20expressions%20of%20peace%20love%20and%20togetherness%20cinematic%20editorial%20photography%20premium%20lifestyle%20warm%20amber%20tones%20shallow%20depth%20of%20field%20beautiful%20tender%20family%20portrait%20Mexico%20serene%20protective%20atmosphere&width=1440&height=1040&seq=pricing-final-cta-coverly-002&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(60,52,137,0.82) 0%, rgba(10,5,30,0.78) 100%)' }} />

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto py-16 md:py-24">
        <h2 className="font-title text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 md:mb-5 leading-tight">
          El mejor momento para organizar a tu familia es hoy.
        </h2>
        <p className="text-white/65 text-sm md:text-lg leading-relaxed mb-6 md:mb-10 max-w-xl mx-auto">
          Sin tramites complicados. Sin visitas a oficinas. Todo desde tu celular en pocos minutos.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center w-full sm:w-auto">
          <a
            href={WA_GENERAL}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#534AB7] hover:bg-[#EEEDFE] font-bold px-8 md:px-9 py-4 rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap text-sm md:text-base cursor-pointer w-full sm:w-auto min-h-[52px]"
          >
            <span>Contratar ahora</span>
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </a>
          <a
            href={CALL_ADVISOR}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white hover:border-white hover:bg-white/10 font-semibold px-8 md:px-9 py-4 rounded-full transition-all duration-300 whitespace-nowrap text-sm md:text-base cursor-pointer w-full sm:w-auto min-h-[52px]"
          >
            <i className="ri-phone-line text-base leading-none"></i>
            <span>Hablar con un asesor</span>
          </a>
        </div>

        <p className="text-white/35 text-xs mt-6 md:mt-8">
          Servicios segun plan · Sin contratos forzosos · Tu decides como continuar.
        </p>
      </div>
    </section>
  );
}
